<template>
  <input type="text"
         name="phone-field-component"
         v-model="phone"
         :id="id"
         class="form-control input-dirty"
         placeholder="+38 (___) ___-__-__"
         aria-describedby="phone"
         autocomplete="key-append-recipient"
  >
</template>

<script>
  const uniqueId = require('lodash.uniqueid')
  import Inputmask from "inputmask"
  import {phoneClean} from "@/helpers/phone";

  export default {
    name: 'DashboardFieldPhone',
    props: {
      set_phone: String
    },
    data(){
      return {
        id: null,
        phone: ''
      }
    },
    mounted() {
      this.id = `phone-${uniqueId()}`
      if (this.set_phone){
        this.phone = phoneClean(this.set_phone).slice(2)
      }
      this.$nextTick(function () {
        let phoneSelector = document.getElementById(this.id);
        if (phoneSelector !== null) {
          let maskPhone = new Inputmask({mask: "+38 (999) 999-99-99", greedy: false})
          maskPhone.mask(phoneSelector)
        }
      })
    }
  }
</script>

<style scoped lang="scss">
</style>